import React, {useState} from "react";
import { useNavigate, useLocation } from "react-router";
import { Routes, Route, Link, Outlet } from 'react-router-dom'
import * as s from './Insurance.style';
// Components
import Sidebar from '../../components/sidebar/Sidebar';


const Insurance = () => {
    return (
        <s.App className="p-0">
          <Sidebar/>
          <s.ContentView className="p-0">
            <Outlet />
          </s.ContentView>
        </s.App>
      );
};
export default Insurance;